import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import Nav from './components/Nav';
import Utils from './pages/Utils';
import Tidings from './pages/Tidings/Tidings';
import 'reactstrap';
import './App.css';
import image from './assets/images/robert-lamb-5398-unsplash.jpg';

const Index = () => (
  <div className="App">
    <header className="App-header">
      <div className="image-cropper">
        <img className="rounded" src={image} />
      </div>
      <h3>
        1024
      </h3>
    </header>
  </div>
);

class App extends Component {
  render() {
    return (
      <Router>
          <div className="row">
            <div className="col-sm-2">
              <Nav />
            </div>
            <div className="col">
              <Route exact path="/" component={Utils} />
              <Route path="/utils" component={Utils} />
              <Route exact path="/tidings" component={Tidings} />
            </div>
          </div>
      </Router>
    );
  }
}

export default App;
